export default __webpack_public_path__ + "static/media/levelTest-Illustration04.1c970d41.jpg";